"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgPenTool = function SvgPenTool(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M13.954 13a.99.99 0 01.087.001l.039.003c.05.004.103.012.155.025l-.078-.016.043.008.035.008 14.5 3.5a1 1 0 01.746.776l1.153 5.765a1 1 0 011.074.224l3 3a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-3-3a1 1 0 01-.224-1.074l-5.765-1.153a1 1 0 01-.776-.746l-3.5-14.5a1.053 1.053 0 01-.026-.156l-.001-.037a.979.979 0 01.137-.549l.019-.03a.92.92 0 01.136-.17l-.061.067.045-.05.016-.016a1.02 1.02 0 01.3-.207l.016-.007c.1-.044.21-.07.325-.078h.007zm17.047 12.415l-5.586 5.586 1.586 1.586L32.587 27 31 25.415zM17.22 15.806l4.487 4.487a3 3 0 11-1.414 1.414l-4.487-4.487 2.517 10.425 6.348 1.27 4.244-4.244-1.27-6.348-10.425-2.517zM23 22.001a1 1 0 100 2 1 1 0 000-2z",
    id: "pen-tool_svg__a"
  }));
};

var _default = SvgPenTool;
exports["default"] = _default;